module.exports = __webpack_public_path__ + "img/sportips.38a170cc.png";